'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Component = require('../../Component');

var _Component2 = _interopRequireDefault(_Component);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _main = require('../templates/main');

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var preventDefault = function preventDefault() {};
var stopPropagation = function stopPropagation() {};

var Main = function (_View) {
    _inherits(Main, _View);

    function Main(props) {
        var _ret;

        _classCallCheck(this, Main);

        var _this = _possibleConstructorReturn(this, (Main.__proto__ || Object.getPrototypeOf(Main)).call(this, props));

        _this.template = _main2.default;


        var collection = props.collection ? _this._processCollection(props.collection) : props.children;
        _this._preparedList = _this._prepareList(collection);

        _this.state = {
            list: collection
        };

        return _ret = _this, _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Main, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            var list = nextProps.collection ? this._processCollection(nextProps.collection) : nextProps.children;
            this._preparedList = this._prepareList(list);

            this.setState({ list: list }).then(function () {
                var selected = _this2._getSelected();

                if (_this2.props.value !== null && _this2.props.value !== undefined && _this2.props.value !== '' && !selected) {
                    _this2.value = null;
                }
            });

            return this;
        }

        /**
         * ищет значение в коллекции
         * @param {Array} list
         * @param {string} value
         * @return {object}
         */

    }, {
        key: '_getSelected',
        value: function _getSelected() {
            var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._preparedList;
            var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.value;

            // без точного приведения типов, потому что в модель может записаться стринг после ввода через инпут
            return list.find(function (item) {
                return value == item.id;
            });
        }

        /**
         * switch elements
         * @return {Main}
         */

    }, {
        key: '_handleClick',
        value: function _handleClick() {
            var _this3 = this;

            var value = void 0,
                selected = this._getSelected();

            // if we have no selected - get second or first
            if (!selected) {
                value = this._preparedList.length > 1 ? this._preparedList[1].id : this._preparedList[0].id;
            } else {
                this._preparedList.forEach(function (item, i) {
                    // find next after current selected or first
                    if (item.id === selected.id) {
                        if (_this3._preparedList[i + 1]) {
                            value = _this3._preparedList[i + 1].id;
                        } else {
                            value = _this3._preparedList[0].id;
                        }
                    }
                });
            }

            this.value = value;

            return this;
        }
    }, {
        key: '_getListPosition',
        value: function _getListPosition() {
            var height = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            var position = 0,
                i = 0,
                len = this._preparedList.length,
                selected = this._getSelected();

            if (selected) {
                for (i; i < len; i++) {
                    if (this._preparedList[i].id === selected.id) {
                        position = i;
                        break;
                    }
                }

                position = position * height;
            }

            return position * -1;
        }
    }, {
        key: '_rootRef',
        value: function _rootRef(el) {
            if (typeof this.props.elementRef === 'function') {
                this.props.elementRef(el);
            }
        }
    }, {
        key: 'computeStyleHash',
        value: function computeStyleHash() {
            return _get(Main.prototype.__proto__ || Object.getPrototypeOf(Main.prototype), 'computeStyleHash', this).call(this) + String(this.props.error);
        }
    }, {
        key: 'value',
        get: function get() {
            return this.props.value;
        },
        set: function set(value) {
            var target = void 0,
                event = void 0;

            target = Object.assign({}, this, {
                value: value
            });

            event = {
                target: target,
                currentTarget: target,
                preventDefault: preventDefault,
                stopPropagation: stopPropagation,
                type: 'change'
            };

            if (typeof this.props.onChange === 'function') {
                this.props.onChange(event);
            }
        }
    }]);

    return Main;
}(_Component2.default);

Main.defaultProps = {
    processor: null,
    onChange: null
};
Main.propTypes = {
    onChange: _propTypes2.default.func
};
Main.displayName = 'Switcher';
exports.default = Main;